const data = {
  "width": 24,
  "height": 24,
  "body": "<path fill=\"currentColor\" d=\"M0 17.143V24h24v-6.857zm5.143 5.143H1.714v-1.714h3.429zM6.857 8.571h3.429V0h3.429v8.571h3.429l-5.143 5.143z\"/>"
};
exports.__esModule = true;
exports.default = data;